import React from "react";
import { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useHistory, useLocation } from "react-router-dom";
import { useAppUser } from "../../../../../../../../contexts/user-context/UserContext";
import SelectCountry from "../../../../../../../../shared/components/countrySelectorModal/SelectCountry";
import CustomMenu from "../../../../../../../../shared/components/CustomMenu/CustomMenu";
import { DashboardAnnouncementsPages } from "../../../../../../containers/announcements/AnnouncementRoutes";
import AnnoucementSideBarHeader from "../components/AnnoucementSideBarHeader";

const AnnoucementMenuItems = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const [modalShow, setModalShow] = useState(false);
  const appUser = useAppUser();
  return (
    <>
      <Row>
        <Col xs={12}>
          <AnnoucementSideBarHeader />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          {/*{appUser.userRole.isModerator ? (*/}
            <CustomMenu
              data={[
                {
                  onClick: () => {
                    history.push(
                      DashboardAnnouncementsPages.CREATE_ANNOUNCEMENT
                    );
                  },
                  text: "Create Notice",
                  isActive:
                    pathname ===
                    DashboardAnnouncementsPages.CREATE_ANNOUNCEMENT,
                },
                {
                  onClick: () => {
                    history.push(DashboardAnnouncementsPages.ANNOUNCEMENTS);
                  },
                  text: "Notices",
                  isActive:
                    pathname === DashboardAnnouncementsPages.ANNOUNCEMENTS,
                },
              ]}
            />
          {/*) : (
            <CustomMenu
              data={[
                {
                  onClick: () => {
                    history.push(DashboardAnnouncementsPages.ANNOUNCEMENTS);
                  },
                  text: "Notices",
                  isActive:
                    pathname === DashboardAnnouncementsPages.ANNOUNCEMENTS,
                },
              ]}
            />
          )
          }*/}
        </Col>
      </Row>
      {appUser.userRole.isAdmin && (
        <SelectCountry
          show={modalShow}
          onHide={() => {
            setModalShow(false);
          }}
        />
      )}
    </>
  );
};

export default AnnoucementMenuItems;
